import axios from 'axios'

export const getStages = companyId => {
    const pathname = window.location.pathname;
    const isOnboardingPage = pathname.includes('/onboarding');
    const url = companyId ? `company/stage/get/${companyId}` : 'company/stage/get';
    const params = isOnboardingPage ? { onboarding: true } : {};
    
    return axios.get(url, { params }).then(({ data }) => data);
}

export const getOnboardingStagesDocuments = companyId =>
    axios.get(companyId ? `company/stage/onboarding-documents/${companyId}` : 'company/stage/onboarding-documents')
        .then(({ data }) => data)